import {Component, ElementRef, Input} from '@angular/core';
import {MatDialog, PageEvent} from "@angular/material";
import {kanNotesService} from "../../../../services/services/notes";
import {Note} from "../../../../../classes/note";
import {kanUsersService} from "../../../../services/services/users";
import {User} from "../../../../../classes/user";
import {Dog} from "../../../../../classes/dog";
import {kanDogsService} from "../../../../services/services/dogs";
import {kanNoteDialog} from "../../../dialogs/note-dialog/component";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-notes',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanNotes {

    @Input() selectedTab: number;
    @Input() tabNumber: number = 0;
    @Input() userId: string;
    @Input() dogId: string;
    public loading: boolean = false;
    public notes: Note[] = [];
    private users: User[] = [];
    private dogs: Dog[] = [];
    public search: string = '';
    public pageIndex: number = 0;
    public pageSize: number = 20;
    public totalNotes: number = 0;
    public showResolved: boolean = false;
    public filter: any = {
        where: {
            and: [
                {
                    resolved: false
                }
            ]
        },
        include: ['user', 'dog'],
        skip: 0,
        limit: 20
    };
    public timeout: any;

    constructor(private element: ElementRef,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private notesService: kanNotesService,
                private usersService: kanUsersService,
                private dogsService: kanDogsService) {
    }

    ngOnInit(): void {
        this.filter = {
            where: {
                and: []
            },
            include: ['user', 'dog'],
            skip: 0,
            limit: 20
        };
        if (!this.userId && !this.dogId) {
            this.filter.where.and.push({
                resolved: false
            });
        } else if (this.userId && !this.dogId) {
            this.filter.where.and.push({
                resolved: false,
                userId: this.userId
            });
        } else if (!this.userId && this.dogId) {
            this.filter.where.and.push({
                resolved: false,
                dogId: this.dogId
            });
        } else if (this.userId && this.dogId) {
            this.filter.where.and.push({
                resolved: false,
                userId: this.userId,
                dogId: this.dogId
            });
        }
    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === this.tabNumber) {
            this.getNotes();
            this.getUsers();
            this.getDogs()
        }
    }

    get role(): string {
        return this.authService.role;
    }

    public getNotes(): void {

        this.loading = true;
        this.notesService.countNotes(this.filter.where)
            .then((count) => {
                this.totalNotes = count;
                return this.notesService.getNotes(this.filter);
            })
            .then((notes) => {
                this.notes = notes;
                this.loading = false;
                this.element.nativeElement.querySelector('.kan-notes-container').scrollTop = 0;
            })
            .catch((error) => {
                console.log(error);
                this.loading = false;
            });
    }

    public getUsers() {
        this.usersService.getUsers({
            where: {
                role: 'USER',
                active: true
            }
        })
            .then((users: User[]) => {
                this.users = users;
            })
            .catch((error: any) => {
                this.users = [];
                console.log(error);
            });
    }

    public getDogs() {
        this.dogsService.getDogs({
            where: {
                active: true
            }
        })
            .then((dogs: Dog[]) => {
                this.dogs = dogs;
            })
            .catch((error: any) => {
                this.dogs = [];
                console.log(error);
            });
    }

    public add(event) {
        let dialogRef = this.dialog.open(kanNoteDialog, {
            data: {
                userId: this.userId,
                dogId: this.dogId
            },
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result === 'add') {
                    this.getNotes();
                }
            });
    }

    public changePage(event: PageEvent) {

        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.getNotes();
    }

    private getUsersIds() {
        if (!this.userId) {
            return this.users
                .filter((user) => {
                    let arr = (this.search || '').split(' ');
                    let found = true;
                    arr.forEach((item) => {
                        if (item) {
                            found = found &&
                                (user.name.toLowerCase().includes(item.toLowerCase()) ||
                                    (user.surname ? user.surname.toLowerCase().includes(item.toLowerCase()) : false));
                        }
                    });
                    return found;
                })
                .map((user) => {
                    return user.id;
                });
        } else {
            return []
        }
    }

    private getDogsIds() {
        if (!this.dogId && !this.userId) {
            return this.dogs
                .filter((dog) => {
                    let arr = (this.search || '').split(' ');
                    let found = true;
                    arr.forEach((item) => {
                        if (item) {
                            found = found && (dog.name.toLowerCase().includes(item.toLowerCase()));
                        }
                    });
                    return found;
                })
                .map((dog) => {
                    return dog.id;
                });
        } else {
            return [];
        }
    }

    public setFilter() {
        clearTimeout(this.timeout);
        this.loading = true;
        this.pageIndex = 0;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.filter.where = {};

        let userIds = this.getUsersIds();
        let dogIds = this.getDogsIds();

        if (this.showResolved) {
            if (this.userId && !this.dogId) {
                this.filter.where = {
                    and: [
                        {
                            userId: this.userId
                        }
                    ]
                };
            } else if (!this.userId && this.dogId) {
                this.filter.where = {
                    and: [
                        {
                            dogId: this.dogId
                        }
                    ]
                };
            } else if (this.userId && this.dogId) {
                this.filter.where = {
                    and: [
                        {
                            userId: this.userId,
                            dogId: this.dogId
                        }
                    ]
                };
            }
        } else {
            if (!this.userId && !this.dogId) {
                this.filter.where = {
                    and: [
                        {
                            resolved: false
                        }
                    ]
                };
            } else if (this.userId && !this.dogId) {
                this.filter.where = {
                    and: [
                        {
                            resolved: false,
                            userId: this.userId
                        }
                    ]
                };
            } else if (!this.userId && this.dogId) {
                this.filter.where = {
                    and: [
                        {
                            resolved: false,
                            dogId: this.dogId
                        }
                    ]
                };
            } else if (this.userId && this.dogId) {
                this.filter.where = {
                    and: [
                        {
                            resolved: false,
                            userId: this.userId,
                            dogId: this.dogId
                        }
                    ]
                };
            }
        }

        if (this.search.trim()) {

            if (!this.filter.where.and) {
                this.filter.where.and = [];
            }

            let fields = ['notes'];
            this.search.trim().split(/\s+/)
                .forEach((s) => {
                    let andBlock = {
                        or: []
                    };
                    s = s.replace(/[aäàá]/g, '[aäàá]')
                        .replace(/[eëéè]/g, '[eëéè]')
                        .replace(/[iïíì]/g, '[iïíì]')
                        .replace(/[oöóò]/g, '[oöóò]')
                        .replace(/[uüúù]/g, '[uüúù]')
                        .replace(/\./g, '\\.');
                    fields.forEach((field) => {
                        let orBlock = {};
                        orBlock[field] = {
                            like: `.*${s}.*`,
                            options: 'i'
                        };
                        andBlock.or.push(orBlock);
                    });

                    if (userIds.length) {
                        andBlock.or.push({
                            userId: {inq: userIds}
                        });
                    }

                    if (dogIds.length) {
                        andBlock.or.push({
                            dogId: {inq: dogIds}
                        });
                    }

                    this.filter.where.and.push(andBlock);
                });
        }
        this.timeout = setTimeout(() => {
            this.getNotes();
        }, 800);
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/notes/notes/component.ts